export const COLUMNS = {
  altFormPrimaryColor: 'altFormPrimaryColor',
  altFormTheme: 'altFormTheme',
  campaignId: 'campaignId',
  checkbox: 'checkbox',
  favicon: 'favicon',
  forms: 'forms',
  host: 'host',
  index: 'index',
  mainFormEsPrimaryColor: 'mainFormEsPrimaryColor',
  mainFormEsTheme: 'mainFormEsTheme',
  mainFormPrimaryColor: 'mainFormPrimaryColor',
  mainFormTheme: 'mainFormTheme',
  ocsDefaultRedirect: 'ocsDefaultRedirect',
  ogImage: 'ogImage',
  pages: 'pages',
  rootRedirect: 'rootRedirect',
  tags: 'tags',
  website: 'website',
};
